<div class="size-48">
  <app-image-thumbnail size="full">
    <img
      [alt]="logoAlt()"
      [fill]="true"
      [ngSrc]="logoSrc()"
      class="-z-10" />
  </app-image-thumbnail>
</div>
